export const dataStore = {
  profil: {},
  event: [],
};
